<script>
import { mapActions, mapGetters } from "vuex";
import { FormWizard, TabContent, WizardButton } from "vue-form-wizard";
import ComplianceForm from "./ComplianceForm";
import DocumentForm from "./DocumentForm";
import { requiredIf, maxLength } from "vuelidate/lib/validators";
import CheckedInUserModal from "./CheckedInUserModal.vue";
import visitService from "@/services/visit";
import siteService from "@/services/sites";
import userService from "@/services/users";
import integtationService from "@/services/integration";
import { cloneDeep , toUpper , debounce} from "lodash";
import RenderFieldType from "@/components/users/section/RenderFieldType";
import { getCustomFieldsPayload } from "@/utils/mixins/customFieldValueParser";
// eslint-disable-next-line no-unused-vars
import { toUpperMixin }  from "@/utils/mixins/toUpper";

export default {
  name: "ActionForm",
  components: {
    FormWizard,
    TabContent,
    WizardButton,
    ComplianceForm,
    DocumentForm,
    CheckedInUserModal,
    RenderFieldType,
  },
  props: [
    "parentGrid",
    "isNewUser",
    "existingUserInfo",
    "newUserInfo",
    "quickSignInArea",
    "quickSignInSite",
    "submitFormStatus",
  ],
  data() {
    return {
      signOutBtnValue:"SIGN OUT",
      hostLoader: false,
      apiChecksLoader: true,
      customSections: null,
      journeyHasCustomFields: false,
      getLoadingStatus: false,
      areaStatus: {},
      isUserSignedIn: null,
      attendanceMode: null,
      validateSignOut: null,
      attendanceCodeInMode: "",
      hostErrorMessage: null,
      isAttendanceModePermitted: null,
      compliances: [],
      documents: [],
      attendanceModeReasons: [],
      flowHasMaskCheck: null,
      flowHasTemperatureCheck: false,
      showHostTab: null,
      journeyFlowId: null,
      allow_not_select_host: null,
      haveUsersToSelectAsHost: null,
      temperature_threshold: null,
      skipTabContent: 1,
      areaChecksDone: false,
      siteLoading: null,
      compliancesNotes: [],
      isOptional: false,

      siteErrMsg: null,
      vaccineComplianceName: null,
      siteDetails: {},
      siteOptions: [],
      isVaccineRequired: null,
      vaccineProtocolOptions: [],
      vaccineProtocol: null,
      isPcrEnabled: false,
      hideIcon: false,
      checksNote: "",
      documentNotes: "",
      showReasonTab: false,
      host: null,
      isNoHostSelected: false,
      hostOptions: [],
      // checksStatus: false,
      notes: "",
      buttonValue: "",
      hideSiteAndArea: false,
      site: null,
      disableSite: false,
      area: null,
      disableArea: false,
      areaOptions: [],
      areaLoading: false,
      // mask_check: false,
      isSignedOut: false,
      // compliances: null,

      valid_temperature: false,
      // compliancesStatus: [],
      // isCompliancesValid: null,
      currentComplainceValid: null,
      regEmail:
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      userSearchLabel: "userName_with_userType",
      documentComplianceId: null,
      scan: {
        temperature: 36,
        temperature_type: "c",
        mask: false,
        area_id: null,
        data_type_id: null,
      },
      visit: {
        user_id: null,
        entity_id: null,
        scan_data_type_id: null,
        timezone: null,
      },
      vaccine_pcr: {
        flow_has_vaccine: null,
        document: null,
        documentOptions: [
          {
            id: 1,
            name: "document_1",
          },
          {
            id: 2,
            name: "document_2",
          },
        ],
        vaccine_pcr: "vaccine",
        vaccine_name: null,
        vaccine_number: null,
        vaccine_given_date: null,
        vaccine_expire_date: null,
        vaccine_document: null,
        vaccine_protocol: null,
        pcr_result: null,
        pcr_document: null,
        pcr_date: null,
        notes: "",
      },
      submitted: null,
      user_id: null,
      default_walk_in: false,
      isDefaultUser: false,
      reason: null,
      showModalMessage: null,
      attendanceModeErrMsg: "",
      userHasVisitToDayInOnOfSites: false,
      hostMessage: "",
      dontChangeArea: false,
    };
  },
  validations: {
    vaccine_pcr: {
      vaccine_name: {
        required: requiredIf(function () {
          return (
            this.vaccine_pcr.vaccine_pcr === "vaccine" &&
            this.vaccine_pcr.flow_has_vaccine &&
            !this.vaccine_pcr.document
          );
        }),
        maxLength: maxLength(30),
      },
      vaccine_given_date: {
        required: requiredIf(function () {
          return (
            this.vaccine_pcr.vaccine_pcr === "vaccine" &&
            this.vaccine_pcr.flow_has_vaccine &&
            !this.vaccine_pcr.document
          );
        }),
      },
      vaccine_expire_date: {
        required: requiredIf(function () {
          return (
            this.vaccine_pcr.vaccine_pcr === "vaccine" &&
            this.vaccine_pcr.flow_has_vaccine &&
            !this.vaccine_pcr.document
          );
        }),
      },
      vaccine_document: {
        required: requiredIf(function () {
          return (
            this.vaccine_pcr.vaccine_pcr === "vaccine" &&
            this.vaccine_pcr.flow_has_vaccine &&
            !this.vaccine_pcr.vaccine_document &&
            !this.vaccine_pcr.document
          );
        }),
      },
      vaccine_protocol: {
        required: requiredIf(function () {
          return (
            this.vaccine_pcr.vaccine_pcr === "vaccine" &&
            this.vaccine_pcr.flow_has_vaccine &&
            !this.vaccine_pcr.vaccine_protocol &&
            !this.vaccine_pcr.document
          );
        }),
      },
      pcr_date: {
        required: requiredIf(function () {
          return (
            this.vaccine_pcr.vaccine_pcr === "pcr" &&
            this.vaccine_pcr.flow_has_vaccine &&
            !this.vaccine_pcr.document
          );
        }),
      },
      pcr_document: {
        required: requiredIf(function () {
          return (
            this.vaccine_pcr.vaccine_pcr === "pcr" &&
            this.vaccine_pcr.flow_has_vaccine &&
            !this.vaccine_pcr.pcr_document &&
            !this.vaccine_pcr.document
          );
        }),
      },
      pcr_result: {
        mustBeNegative: function (pcrResult) {
          if (
            !this.vaccine_pcr.document &&
            this.vaccine_pcr.vaccine_pcr === "pcr" &&
            this.vaccine_pcr.flow_has_vaccine &&
            !this.vaccine_pcr.document
          ) {
            return (
              (pcrResult?.value && this.documentNotes.length >= 20) ||
              pcrResult?.value === false
            );
          }
          return true;
        },
      },
    },
    scan: {
      temperature: {
        temperatureValidation() {
          let scanTempInCelsius = this.scan.temperature;

          if (this.scan.temperature_type == "f")
            scanTempInCelsius = ((this.scan.temperature - 32) * 5) / 9;

          if (
            this.flowHasTemperatureCheck &&
            scanTempInCelsius > +this.temperature_threshold &&
            this.checksNote?.length < 20
          )
            return false;
          return true;
        },
      },
      mask: {
        maskValidation() {
          if (
            this.flowHasMaskCheck &&
            this.scan.mask === false &&
            this.checksNote?.length < 20
          )
            return false;
          return true;
        },
      },
    },
    host: {
      required: requiredIf(function () {
        return this.showHostTab && !this.isNoHostSelected;
      }),
    },
    compliances: {
      $each: {
        answer: {
          $each: {
            pivot: {
              answer: {
                desiredAnswer: function (pivot, pivotParent) {
                  let complianceIndex = this.compliances?.findIndex(
                    (compliance) => compliance.id == pivotParent?.complianceId
                  );
                  complianceIndex =
                    complianceIndex >= 0 ? complianceIndex : null;

                  if (
                    pivot && //extra (expected hanlding)
                    (JSON.parse(pivot?.desired) == true ||
                      (JSON.parse(pivot?.desired) == false &&
                        this.compliancesNotes[
                          complianceIndex || pivot?.complianceIndex
                        ]?.length >= 20))
                  )
                    return true;
                  return false;
                },
              },
            },
          },
        },
      },
    },
    areaStatus: {
      errorValidation(status) {
        if (
          this.checksNote?.length < 20 &&
          (status?.attendanceMode ||
            status?.journey ||
            status?.expected ||
            status?.attendanceModeDuration)
        )
          return false;
        return true;
      },
    },
    reason: {
      required: requiredIf(function () {
        return this.showReasonTab;
      }),
    },
    customSections: {
      $each: {
        custom_fields: {
          $each: {
            value: {
              required: requiredIf(function (field) {
                // console.log({ field });
                return field.is_mandatory;
              }),
            },
          },
        },
      },
    },
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo", "getModalState"]),
    ...mapGetters("visit", ["getIsQuickSignInSubmitClicked"]),
    ...mapGetters("sites", [
      "getStatusForArea",
      "getStatusesForArea",
      "getSignedInUserVisitDetails",
    ]),
    ...mapGetters("authfack", ["currentEntity", "userDetails"]),
    showWizardNavButtons() {
      return (
        this.compliances?.length ||
        this.vaccine_pcr?.flow_has_vaccine ||
        this.showHostTab ||
        this.showReasonTab ||
        this.journeyHasCustomFields
      );
    },
    customSectionSkipIndex() {
      return (
        this.compliances.length +
        this.skipTabContent +
        (this.vaccine_pcr?.flow_has_vaccine ? 1 : 0)
      );
    },
    isQuickSignIn() {
      return this.parentGrid == "quickSignIn";
    },
    showFormWizard() {
      return this.isAttendanceModePermitted && this.areaChecksDone;
    },
    showSignInWizard() {
      return !this.isUserSignedIn || this.isDefaultUser;
    },
    isChecksTabInvalid() {
      let checksHasError = false;
      Object.keys(this.areaStatus)?.forEach((key) => {
        if (
          key == "journey" ||
          key == "attendanceMode" ||
          key == "attendanceModeDuration" ||
          key == "expected"
        )
          checksHasError = true;
      });
      return checksHasError || this.$v.scan.$invalid;
    },
  },
  watch: {
    getIsQuickSignInSubmitClicked(status) {
      if (status) this.onSubmit();
    },
    getModalState(state) {
      state == true && this.$bvModal.hide("dashboardActionOne");
    },
    host: {
      handler() {
        if (this.host) {
          this.clearNoUserHost();
        }
      },
    },
    isNoHostSelected: {
      handler() {
        if (this.isNoHostSelected) {
          this.clearHost();
        }
      },
    },
    "scan.temperature_type": {
      handler(val) {
        if (val == "c") this.scan.temperature = 37;
        else this.scan.temperature = 98.6;
      },
      deep: true,
    },
    $v: {
      handler() {
        let isInvalid = true;
        if (this.isUserSignedIn) {
          isInvalid =
            this.$v.reason.$invalid ||
            this.$v.areaStatus.$invalid ||
            this.$v.customSections.$invalid ||
            this.getLoadingStatus ||
            !this.areaChecksDone;
        } else {
          isInvalid =
            this.$v.$invalid || this.getLoadingStatus || !this.areaChecksDone;
        }
        this.$emit("userCheckinFormInvalid", isInvalid);
      },
      deep: true,
    },
    getLoadingStatus(status) {
      console.log(status);
      this.$emit("userCheckinFormInvalid", status);
    },
  },
  created() {
    this.findHost = debounce(this.findHostName.bind(this), 500);
  },
  methods: {
    ...mapActions("sites", ["checkUserHasVisitToday"]),
    ...mapActions("dailyLogbook", [
      "dashboardAction",
      "checkInUserAction",
      "fetchScanDatatypes",
    ]),
    ...mapActions("userType", ["fetchAvailableHosts"]),
    async updateSite(site) {
      this.hostMessage = "";
      this.hostErrorMessage = "";
      this.areaLoading = true;
      this.areaOptions = [];
      this.isAttendanceModePermitted = null;
      this.area = null;
      this.siteErrMsg = null;
      //Check if signed/checked in user type has changed to unpermitted user type

      // isNewUser => flag from "quick sign in" form, to indicates whether thats
      // a new user or existing one.
      // skip check if new user is added since they won't have an expected visit.
      if (!this.isNewUser) {
        const { data } = await siteService.checkIfExpectedIsPermitted({
          userId: this.user_id,
          siteId: site.id,
          userTypeId:
            this.getModalInfo?.user_type_id ||
            this.existingUserInfo.user_type_id,
        });

        if (data.expected) {
          this.siteErrMsg = data.expected;
          return;
        }
      }

      // if (!this.dontChangeArea) this.area = null;
      this.submitted = null;

      this.areaOptions = site ? site.areas : [];

      if (
        this.areaOptions.length == 1 &&
        !this.areaOptions[0]?.children?.length
      ) {
        this.area = this.site.areas[0];
        this.updateArea(this.area);
      }
    },
    async updateArea(area) {
      if (!area) {
        this.resetSignInData();
        return;
      }

      this.resetSignInData();

      this.areaChecksDone = false;

      const wiz_nav = this.$el.querySelector(".wizard-nav-pills");
      if (wiz_nav)
        this.$el.querySelector(".wizard-nav-pills").style.display = "none";

      const wondeIntegrations = await integtationService.getWondeIntegrations();
      const integration_ids =
        wondeIntegrations?.map((integration) => integration.id) || "";

      let visitData = {};
      if (this.isNewUser) {
        const { data } = await visitService.signInOutByUserType({
          user_type_id: this.user_type_id,
          area_id: area.id,
          integration_ids,
        });
        visitData = data;
      } else {
        const { data } = await visitService.signInOut({
          user_id: this.user_id,
          area_id: area.id,
          integration_ids,
        });
        visitData = data;
      }

      // Display modal and prevent area checks if error is returned
      // this.$bvModal.show('attendanceModeDeniedAccess')

      this.setJourneyFlowChecks(visitData, area);
    },
    backBtnDisabled(currentActiveIndex) {
      const isDisabled = currentActiveIndex == 0;
      this.$emit("setShowSiteAndArea", isDisabled);
      return isDisabled;
    },
    //not used
    setActiveTabIndex(tabIndex) {
      console.log(tabIndex);
      // this.$emit('userCheckinWizardCurrentTabIndex',tabIndex)
    },
    updateCustomField(field) {
      this.customSections?.forEach((section, sectionIndex) => {
        let updatedFieldIndex = section.custom_fields?.findIndex(
          (customField) => customField.id == field.id
        );

        if (updatedFieldIndex >= 0)
          this.customSections[sectionIndex].custom_fields[updatedFieldIndex] =
            field;
      });

      this.customSections = cloneDeep(this.customSections);
    },
    setWizardButtonValue(areaLoginMode) {
      this.buttonValue =
        areaLoginMode == "checkIn_only"
          ? toUpper(this.$t("common.checkIn"))
          : toUpper(this.$t("common.signIn"));

      if (this.isQuickSignIn)
        this.$emit("setWizardButtonValue", areaLoginMode, this.isUserSignedIn);
    },
    setAreaStatus(notesAndErrors) {
      this.areaStatus = notesAndErrors;
      this.$emit("setAreaStatus", notesAndErrors);
    },
    setJourneyChecks(checks) {
      checks?.forEach((check) => {
        //Mask & Temperature checks
        if (check.name == "mask_check")
          this.flowHasMaskCheck = !!Number(check.value);
        if (check.name == "temperature_check")
          this.flowHasTemperatureCheck = !!Number(check.value);

        if (check.name == "temperature_threshold") {
          if (
            check.value?.toString()?.toLowerCase().includes("f") ||
            parseFloat(check.value) > 85
          )
            this.temperature_threshold =
              ((parseFloat(check.value) - 32) * 5) / 9;
          else this.temperature_threshold = check.value;
        }

        //Host checks
        if (check.name == "host" && check.value) {
          this.journeyFlowId = check.journey_flow_id;
          this.showHostTab = true;
          this.skipTabContent++;
        }

        if (check.name == "allow_not_select_host")
          this.allow_not_select_host = !!Number(check.value);

        if (check.name == "select_host_permitted")
          this.haveUsersToSelectAsHost = check.value;
      });
    },
    async setAttendanceMode(
      attendanceModeReasons,
      attendanceCodeInMode,
      isAttendanceModePermitted
    ) {
      this.attendanceCodeInMode = attendanceCodeInMode;
      this.isAttendanceModePermitted = isAttendanceModePermitted;
      this.attendanceModeReasons = [];
      attendanceModeReasons?.forEach((reason) => {
        if (reason.presented?.length)
          reason.presented?.forEach((presentedReason) =>
            this.attendanceModeReasons.push({
              name: presentedReason,
              isPresented: true,
              reason_id: reason.id,
              attendance_code: reason.attendance_code,
            })
          );
        else
          this.attendanceModeReasons.push({
            name: reason.name,
            isPresented: false,
            reason_id: reason.id,
            attendance_code: reason.attendance_code,
          });
      });

      //Hide reasons tab if there is only one reason option & select it
      if (this.attendanceModeReasons?.length == 1) {
        this.reason = this.attendanceModeReasons[0];
      } else if (this.attendanceModeReasons?.length > 1) {
        this.showReasonTab = true;
        this.skipTabContent++;
      }

      if (this.isAttendanceModePermitted === false) {
        this.attendanceModeErrMsg = !this.isUserSignedIn
          ? "You can't sign this user into this area because you don't have access to the applied attendance mode."
          : "You can't sign this user out from this area because you don't have access to the applied attendance mode.";
      }
    },
    setUserHost(host) {
      if (host === true) {
        this.isNoHostSelected = true;
        this.host = null;
      } else this.host = host;
    },
    setCompliance(complianceData) {
      if (!complianceData?.length) return;
      this.compliances =
        complianceData?.map((complinace, i) => {
          this.compliancesNotes[i] =
            complinace.pivot &&
            complinace.pivot.metadata &&
            complinace.pivot.metadata[0]
              ? complinace.pivot.metadata[0].notes
              : "";
          return {
            name: complinace.name,
            id: complinace.id,
            answer: complinace.form_metadata.data
              ? complinace.form_metadata.data
              : complinace.form_metadata.questions,
            pivot: complinace.pivot,
          };
        }) || [];

      this.compliances?.forEach((compliance, complianceIndex) => {
        compliance.answer.forEach((question) => {
          if (
            compliance?.pivot &&
            compliance?.pivot.metadata &&
            compliance?.pivot.metadata[0]
          ) {
            // move user answer to the question
            const userAnswer = compliance?.pivot.metadata.find(
              (metadata) => metadata.body == question.body
            );
            if (userAnswer) {
              Object.assign(userAnswer.answer, { complianceIndex });
              question.pivot = userAnswer;
            } else {
              question.pivot = {
                answer: {
                  text: "",
                  yesAnswer: null,
                  noAnswer: null,
                  desired: null,
                  complianceIndex: complianceIndex,
                },
              };
            }
          } else {
            question.pivot = {
              answer: {
                text: "",
                yesAnswer: null,
                noAnswer: null,
                desired: null,
                complianceIndex: complianceIndex,
              },
            };
          }
        });
      });

      if (this.isUserSignedIn && !this.isDefaultUser) this.compliances = [];
    },
    setCustomFields(sections) {
      this.journeyHasCustomFields = sections?.length > 0;

      this.customSections = sections;

      const skippedWizardTab =
        this.skipTabContent +
        this.compliances.length +
        (this.vaccine_pcr.flow_has_vaccine ? 1 : 0);

      this.customSections?.forEach((section, sectionIndex) => {
        Object.assign(section, {
          sectionIndex: sectionIndex + skippedWizardTab,
        });
        section.custom_fields?.forEach((field) => {
          let defaultValue = null;

          if (field.type == "checkboxes") defaultValue = [];
          else if (field.type == "toggleButton") defaultValue = false;
          else defaultValue = null;

          Object.assign(field, {
            value: defaultValue,
            sectionType: Number(section.type),
          });
        });
      });
    },
    updateCompliance(updatedCompliance) {
      let updatedComplianceIndex = this.compliances.findIndex(
        (compliance) => compliance.id == updatedCompliance.id
      );
      this.compliances[updatedComplianceIndex] = updatedCompliance;

      this.compliances = cloneDeep(this.compliances);
    },
    setDocument(documents) {
      if (!documents || !documents.length) return;
      let documentOptions = [];
      let flow_has_vaccine = null;
      if (documents?.length > 0) flow_has_vaccine = true;
      const { user_documents, complianceDocument } = documents[0];

      this.documentComplianceId =
        complianceDocument && complianceDocument.length
          ? complianceDocument[0].id
          : null;
      this.vaccineComplianceName = complianceDocument[0]?.name || "Vaccine/PCR";
      //Check if compliance is optional
      if (this.documentComplianceId) {
        const questions =
          complianceDocument[0]?.form_metadata?.data[0]?.answers || null;
        this.isOptional =
          questions?.length && questions[0]?.desired && questions[1]?.desired
            ? true
            : false;
        this.isVaccineRequired = true;
      }

      //Check if PCR is enabled
      this.isPcrEnabled = complianceDocument[0]?.form_metadata?.data[0]?.pcr
        ? true
        : false;

      //Filter document if pcr is disabled
      if (user_documents?.length && !this.isPcrEnabled) {
        documentOptions = user_documents.filter(
          (item) => item.type == "covid_vaccine"
        );
      } else {
        documentOptions = user_documents;
      }

      //Set vaccine protocols options
      // this.vaccineProtocolOptions = complianceDocument[0]?.form_metadata?.data[0]?.protocols

      this.vaccine_pcr.flow_has_vaccine = flow_has_vaccine;
      this.vaccine_pcr.documentOptions = documentOptions.map((item) => {
        // console.log(item);
        if (item.type == "covid_pcr") {
          const {
            metadata: {
              certificateModel: { tests },
            },
          } = item;
          return {
            id: item.id,
            name:
              item?.vaccine_document?.pcr_status == "negative"
                ? "Negative PCR"
                : "Positive PCR",
            // name:
            //   tests[0].testResult == "Not detected"
            //     ? "Negative PCR"
            //     : "Positive PCR",
            date: tests[0].dateTimeOfTestResult,
            value: `${
              item?.vaccine_document?.pcr_status == "negative"
                ? "Negative PCR"
                : "Positive PCR"
            }  (${tests[0].dateTimeOfTestResult.substring(0, 10)})`,
            ...item,
          };
        } else if (item.type == "covid_vaccine") {
          const {
            metadata: {
              certificateModel: { vaccinations },
              greenCertificatData: { expirationTime },
            },
          } = item;
          return {
            id: item.id,
            name:
              vaccinations[0].vaccine && vaccinations[0].vaccine.length
                ? vaccinations[0].vaccine
                : "Vaccine",
            date: expirationTime,
            value: `${
              vaccinations[0].vaccine && vaccinations[0].vaccine.length
                ? vaccinations[0].vaccine
                : "Vaccine"
            }  (${expirationTime ? expirationTime.substring(0, 10) : "N/A"})`,
            ...item,
          };
        }
      });

      if (
        complianceDocument &&
        complianceDocument[0] &&
        complianceDocument[0].pivot
      ) {
        this.documentNotes = complianceDocument[0].pivot.metadata
          ? complianceDocument[0].pivot.metadata.notes
          : "";
        const documentSelected = this.vaccine_pcr.documentOptions.find(
          (item) => item.id == complianceDocument[0].pivot.user_document_id
        );
        if (documentSelected) this.vaccine_pcr.document = documentSelected;
        else this.vaccine_pcr.document = null;
        this.vaccine_pcr.pivot = complianceDocument[0].pivot;
      }
    },
    resetSignInData() {
      this.hostMessage = "";
      this.customSections = [];
      this.journeyHasCustomFields = false;

      //reset scan checks
      (this.scan = {
        temperature: 37,
        temperature_type: "c",
        mask: false,
        area_id: null,
        data_type_id: null,
      }),
        //reset document
        (this.vaccine_pcr = {
          flow_has_vaccine: null,
          document: null,
          documentOptions: [],
          vaccine_pcr: "vaccine",
          vaccine_name: null,
          vaccine_number: null,
          vaccine_given_date: null,
          vaccine_expire_date: null,
          vaccine_protocol: null,
          vaccine_document: null,
          pcr_result: null,
          pcr_date: null,
          pcr_document: null,
          notes: "",
        });
      this.mask_check = false;
      this.showHostTab = false;
      this.showReasonTab = false;
      this.isNoHostSelected = false;
      this.host = null;
      this.areaChecksDone = false;
      this.hideSiteAndArea = false;
      this.checksNote = "";
      this.compliancesNotes = [];
      this.compliances = [];
      this.documentComplianceId = null;
      this.skipTabContent = 1;
      this.attendanceModeReasons = [];
      this.attendanceCodeInMode = "";
      this.reason = null;
      this.isAttendanceModePermitted = null;
      this.areaStatus = [];
      this.flowHasMaskCheck = false;
      this.flowHasTemperatureCheck = false;
      const wiz_nav = this.$el.querySelector(".wizard-nav-pills");
      if (wiz_nav) {
        this.$el.querySelector(".wizard-nav-pills").style.display = "none";
      }
    },
    refreshUsersNotOnSiteGrid() {
      this.$emit("refreshNotOnSiteGrid");
    },
    updateIsOptional(isOptionalValue) {
      this.isVaccineRequired = isOptionalValue;
    },
    updateVaccineProtocol(protocol) {
      this.vaccineProtocol = protocol;
    },
    clearHost() {
      this.host = null;
      this.hostOptions = [];
    },
    clearNoUserHost() {
      this.isNoHostSelected = false;
    },
    async findHostName(val, isExpected) {
      this.hostLoader = true;
      try {
        this.userSearchLabel = "userName_with_userType";
        if (!isExpected && !val.trim()) return;
        if (val.length) {
          const journeyFlowId =
            this.journeyFlowId || this.getModalInfo.metadata.journey_flow_id;

          const params = {
            journeyFlowId: journeyFlowId,
            search: isExpected ? val : val.trim(),
            userId: this.user_id,
            user_type_id: this.user_type_id,
            site_id: this.site.id,
          };

          await this.fetchAvailableHosts(params).then(
            (res) => (this.hostOptions = res.data)
          );
          // console.log("this.hostOptions", this.hostOptions);

          let checkStringIsEmail = this.validateEmail(val);
          if (checkStringIsEmail) {
            this.userSearchLabel = "email";
          } else if (!isNaN(val) && !isExpected) {
            this.userSearchLabel = "phone";
          } else {
            this.userSearchLabel = "userName_with_userType";
          }
        } else {
          this.hostOptions = [];
        }
      } catch (e) {
        console.error("Could not fetch host data", e);
      } finally {
        this.hostLoader = false;
      }
    },
    validateEmail(email) {
      let isEmailForm = false;
      if (this.regEmail.test(email)) {
        isEmailForm = true;
      }
      return isEmailForm;
    },
    handleCovidType() {
      switch (this.vaccine_pcr.vaccine_pcr) {
        case "vaccine":
          return "covid_vaccine";
        case "pcr":
          return "covid_pcr";
        default:
          break;
      }
    },
    onWizardTabIndexChange(prevIndex, nextIndex) {
      this.hideSiteAndArea = nextIndex > 0;
    },
    setJourneyFlowChecks(visitData, area) {
      const {
        isUserSignedIn,
        compliances,
        notesAndErrors,
        isAttendanceModePermitted,
        validateSignOut,
        reasons,
        documents,
        attendanceCodeInMode,
        journeyFlowSettings,
        // attendanceMode,
        sections,
        userHost,
      } = visitData;

      this.isUserSignedIn = isUserSignedIn;
      this.validateSignOut = validateSignOut;
      // this.attendanceModeReasons = reasons;
      // this.attendanceMode = attendanceMode;

      const areaSelected =
        this.areaOptions.find((item) => item.id == area) || this.area;
      if (
        areaSelected?.loginMode === "signIn_signOut" ||
        this.area?.loginMode === "signIn_signOut"
      ) {
        this.hostMessage = this.$tc("signInOut.hostMsg", 1);
        this.hostErrorMessage = this.$tc("signInOut.noUsersHostMsg", 1);
      } else if (
        areaSelected?.loginMode === "checkIn_only" ||
        this.area?.loginMode === "checkIn_only"
      ) {
        this.hostMessage = this.$tc("signInOut.hostMsg", 2);
        this.hostErrorMessage = this.$tc("signInOut.noUsersHostMsg", 2);
      }

      this.setWizardButtonValue(
        areaSelected?.loginMode || this.area?.loginMode
      );
      this.setAreaStatus(notesAndErrors);
      this.setJourneyChecks(journeyFlowSettings);
      this.setAttendanceMode(
        reasons,
        attendanceCodeInMode,
        isAttendanceModePermitted
      );
      this.setUserHost(userHost);
      this.setCompliance(compliances);
      this.setDocument(documents);
      this.setCustomFields(sections);

      setTimeout(() => {
        if (
          (!isUserSignedIn &&
            (this.compliances?.length ||
              this.showHostTab ||
              this.vaccine_pcr.flow_has_vaccine)) ||
          this.showReasonTab ||
          this.journeyHasCustomFields
        ) {
          if (this.$el.querySelector(".wizard-nav-pills"))
            this.$el.querySelector(".wizard-nav-pills").style.display = "flex";
        } else {
          if (this.$el.querySelector(".wizard-nav-pills"))
            this.$el.querySelector(".wizard-nav-pills").style.display = "none";
        }
        // else {
        //   if (this.$el.querySelector(".wizard-nav-pills"))
        //     this.$el.querySelector(".wizard-nav-pills").style.display = "none";
        // }
      }, 0);

      this.areaChecksDone = true;
      this.$emit("areaChecksDone", true);
    },
    async onSubmit() {
      this.getLoadingStatus = true;
      this.$v.$touch();

      // userDetails,
      const { currentEntity, getModalInfo, vaccine_pcr, handleCovidType } =
        this;

      let first_name = "";
      let last_name = "";

      //Create new user in case of quick sign in
      if (this.isQuickSignIn) {
        if (this.isNewUser) {
          let formData = new FormData();
          formData.append("entity_id", currentEntity.id);
          formData.append("user_type_id", this.newUserInfo.userType);
          formData.append("first_name", this.newUserInfo.firstName);
          formData.append("last_name", this.newUserInfo.lastName);

          if (this.newUserInfo.email)
            formData.append("email", this.newUserInfo.email ?? "");
          if (this.newUserInfo.phone)
            formData.append("phone", this.newUserInfo.phone ?? "");

          const { data: newUser } = await userService.createUser(formData);

          this.user_id = newUser.id;
          first_name = newUser.first_name;
          last_name = newUser.last_name;
        } else {
          first_name = this.existingUserInfo.first_name;
          last_name = this.existingUserInfo.last_name;
        }
      } else {
        first_name = getModalInfo?.first_name ?? getModalInfo?.user?.first_name;
        last_name = getModalInfo?.last_name ?? getModalInfo?.user?.last_name;
      }

      const {
        // flow_has_vaccine,
        vaccine_name,
        vaccine_number,
        vaccine_given_date,
        vaccine_expire_date,
        pcr_date,
      } = vaccine_pcr;

      const visit = {
        entityId: currentEntity.id,
        userId: this.user_id,
      };

      const scan = {
        areaId: this.area.id,
        userTypeId: this.user_type_id,
        temperature: this.scan.temperature,
        temperatureType: this.scan.temperature_type,
        hasMask: this.scan.mask ? 1 : 0,
        notes: this.checksNote,
        host: null,
      };

      //check if host is available in flow
      if (this.showHostTab && !this.isUserSignedIn) {
        Object.assign(scan, {
          host: this.isNoHostSelected ? null : this.host.user_id,
        });
      }

      // console.log("compliances", this.compliances);
      let answeredCompliance =
        this.compliances?.map((compliance) => {
          // console.log({ compliance });
          return {
            id: compliance.id,
            name: compliance.name,
            answer: compliance.answer.map((item) => {
              // console.log(item.pivot.answer)
              return {
                type: item.type,
                body: item.body,
                complianceId: compliance.id,
                answerImage: "     ",
                answer: item.pivot.answer,
                // answer: Object.assign(item.pivot.answer, {
                //   yesAnswer: item.yesAnswer,
                //   noAnswer: item.noAnswer,
                //   desired: item.isDesired,
                // }),
                // item.yesAnswer && item.noAnswer
                //   ? item.answers
                //   : item.yesAnswer
                //   ? item.answers[0]
                //   : item.answers[1],
              };
            }),
          };
        }) || [];

      let compliances = [];
      answeredCompliance.forEach((compliance, indx) => {
        let answerArr = [];
        let currCompId = "";
        compliance.answer.forEach((answer) => {
          currCompId = answer.complianceId;
          let complianceObject = {
            body: answer.body,
            complianceId: answer.complianceId,
            type: answer.type,
            // actionBy: userDetails.isAdmin ? "Admin" : "User",
            actionBy: "Admin",
            notes: this.compliancesNotes[indx],
            answer: Object.assign(answer.answer, {
              answerImage: answer.answerImage,
            }),
          };
          answerArr.push(complianceObject);
        });
        compliances.push({
          answer: answerArr,
          complianceId: currCompId,
          name: compliance.name,
        });
      });

      const vaccineData = {
        certificateModel: {
          extraData: vaccine_expire_date ?? "",
          dateOfBirth: "",
          kid: "",
          person: {
            familyName: last_name,
            givenName: first_name,
            standardisedFamilyName: last_name,
            standardisedGivenName: first_name,
          },
          signature: "",
          vaccinations: [
            {
              certificateIdentifier: "",
              certificateIssuer: "",
              countryOfVaccination: "",
              dateOfVaccination: vaccine_given_date,
              disease: "COVID-19",
              doseNumber: "",
              manufacturer: "",
              medicinalProduct: "",
              totalSeriesOfDoses: "",
              batchNumber: vaccine_number,
              vaccine: vaccine_name,
            },
          ],
        },
        generalVerificationResult: "",
        greenCertificatData: {
          expirationTime: vaccine_expire_date ?? "",
          issuedAt: "",
          issuingCountry: "",
        },
        type: "",
        notes: vaccine_pcr.notes,
        protocol: this.vaccineProtocol,
      };

      const pcrData = {
        certificateModel: {
          dateOfBirth: "",
          kid: "",
          person: {
            familyName: last_name,
            givenName: first_name,
            standardisedFamilyName: last_name,
            standardisedGivenName: first_name,
          },
          signature: "",
          tests: [
            {
              disease: "",
              typeOfTest: "",
              testName: "",
              testNameAndManufacturer: null,
              dateTimeOfCollection: "",
              dateTimeOfTestResult: pcr_date,
              testResult: this.vaccine_pcr.pcr_result?.value,
              testResultCode: "260415000",
              testingCentre: "",
              countryOfVaccination: "",
              certificateIssuer: "",
              certificateIdentifier: "",
              countryCode: "",
            },
          ],
        },
        generalVerificationResult: "",
        greenCertificatData: {
          expirationTime: "",
          issuedAt: "",
          issuingCountry: "",
        },
        type: "INTERNATIONAL",
        notes: vaccine_pcr.notes,
      };
      let documents = {};
      if (this.documentComplianceId) {
        documents = {
          complianceId: this.documentComplianceId ?? null,
          document_id: this.vaccine_pcr.document
            ? this.vaccine_pcr.document.id
            : "",
          notes: this.documentNotes,
          data: {
            entity_id: currentEntity.id,
            metadata:
              vaccine_pcr.vaccine_pcr == "vaccine" ? vaccineData : pcrData,
            // notes:,
            user_id: this.user_id,
            expiry_date: vaccine_expire_date,
            start_date: vaccine_pcr.vaccine_pcr == "vaccine" ? null : pcr_date,
            notes: vaccine_pcr.notes,
            type: handleCovidType(),
            fileAttach:
              vaccine_pcr.vaccine_pcr == "vaccine"
                ? vaccine_pcr.vaccine_document
                : vaccine_pcr.pcr_document,
          },
        };
      }

      let formData = new FormData();
      formData.append("isSignedIn", !this.isUserSignedIn);
      formData.append("visit[userId]", visit?.userId);
      formData.append("visit[entityId]", visit?.entityId);
      formData.append("scan[areaId]", scan?.areaId);
      formData.append("scan[userTypeId]", scan?.userTypeId);
      if (this.flowHasTemperatureCheck && !this.isUserSignedIn) {
        formData.append("scan[temperature]", scan?.temperature);
        formData.append("scan[temperatureType]", scan?.temperatureType);
      } else {
        formData.append("scan[temperature]", "0");
        formData.append("scan[temperatureType]", "c");
      }
      if (this.flowHasMaskCheck && !this.isUserSignedIn)
        formData.append("scan[hasMask]", scan?.hasMask);
      else formData.append("scan[hasMask]", "-1");

      formData.append("scan[notes]", scan?.notes);
      formData.append("scan[host]", scan?.host ?? "");
      formData.append(
        "scan[attendanceCodeId]",
        this.reason?.attendance_code?.id ||
          this.attendanceCodeInMode?.pivot?.code_id ||
          ""
      );
      formData.append("scan[reasonId]", this.reason?.reason_id ?? "");
      formData.append(
        "scan[reasonPresentName]",
        this.reason?.isPresented ? this.reason.name : ""
      );

      if (this.customSections) {
        let customFields = getCustomFieldsPayload(this.customSections);
        formData.append("custom_fields", JSON.stringify(customFields));
      }

      if (compliances.length)
        formData.append("compliances", JSON.stringify(compliances));
      else formData.append("compliances", []);

      if (
        this.documentComplianceId &&
        (documents?.document_id || documents?.data?.fileAttach)
      ) {
        formData.append(
          "document[data][fileAttach]",
          documents?.data?.fileAttach ?? ""
        );
        formData.append("document[document_id]", documents?.document_id ?? "");
        formData.append(
          "document[complianceId]",
          this.documentComplianceId ?? ""
        );
        formData.append(
          "document[data][entity_id]",
          documents?.data?.entity_id ?? ""
        );
        formData.append(
          "document[data][expiry_date]",
          documents?.data?.expiry_date ?? ""
        );
        formData.append(
          "document[data][metadata][fileAttach]",
          documents?.data?.fileAttach ?? ""
        );

        // formData.append("document[data][metadata]", documents?.data?.metadata??'')
        formData.append(
          "document[data][metadata][protocol]",
          this.vaccineProtocol ?? ""
        );
        formData.append(
          "document[data][metadata][certificateModel][extraData]",
          vaccine_expire_date ?? ""
        );
        formData.append(
          "document[data][metadata][certificateModel][dateOfBirth]",
          ""
        );
        formData.append("document[data][metadata][certificateModel][kid]", "");
        formData.append(
          "document[data][metadata][certificateModel][person][familyName]",
          last_name ?? ""
        );
        formData.append(
          "document[data][metadata][certificateModel][person][givenName]",
          first_name ?? ""
        );
        formData.append(
          "document[data][metadata][certificateModel][person][standardisedFamilyName]",
          last_name ?? ""
        );
        formData.append(
          "document[data][metadata][certificateModel][person][standardisedGivenName]",
          first_name ?? ""
        );
        formData.append(
          "document[data][metadata][certificateModel][signature]",
          ""
        );
        formData.append(
          "document[data][metadata][generalVerificationResult]",
          ""
        );
        formData.append(
          "document[data][metadata][greenCertificatData][expirationTime]",
          vaccine_expire_date ?? ""
        );
        formData.append(
          "document[data][metadata][greenCertificatData][issuedAt]",
          ""
        );
        formData.append(
          "document[data][metadata][notes]",
          documents?.data?.notes ?? ""
        );
        formData.append(
          "document[data][metadata][type]",
          documents?.data?.type ?? ""
        );

        if (vaccine_pcr.vaccine_pcr == "vaccine") {
          for (
            let i = 0;
            i < vaccineData.certificateModel.vaccinations.length;
            i++
          ) {
            for (let key of Object.keys(
              vaccineData.certificateModel.vaccinations[i]
            )) {
              formData.append(
                `document[data][metadata][certificateModel][vaccinations][${i}][${key}]`,
                vaccineData.certificateModel.vaccinations[i][key] ?? ""
              );
            }
          }
        } else if (
          vaccine_pcr.vaccine_pcr == "covid_pcr" ||
          vaccine_pcr.vaccine_pcr == "pcr"
        ) {
          for (let i = 0; i < pcrData.certificateModel.tests.length; i++) {
            for (let key of Object.keys(pcrData.certificateModel.tests[i])) {
              formData.append(
                `document[data][metadata][certificateModel][tests][${i}][${key}]`,
                pcrData.certificateModel.tests[i][key] ?? ""
              );
            }
          }
        }

        formData.append("document[data][notes]", documents?.data?.notes ?? "");
        formData.append("document[notes]", this.documentNotes ?? "");
        formData.append(
          "document[data][start_date]",
          documents?.data?.start_date ?? ""
        );
        formData.append(
          "document[data][user_id]",
          documents?.data?.user_id ?? ""
        );
        formData.append("document[data][type]", documents?.data?.type ?? "");
      } else {
        formData.append("document", []);
      }

      await this.checkInUserAction(formData);
      this.parentGrid == "notOnSite" ? this.refreshUsersNotOnSiteGrid() : null;
      this.$emit("submitted", true);
      this.$bvModal.hide("quickSignIn");
      this.$bvModal.hide("dashboardActionOne");
    },
    async setMountData() {
      try {
        this.signOutBtnValue = toUpperMixin(this.$t("common.signOut"));

        if (!this.showModalMessage) {
          await this.fetchScanDatatypes();
          await this.setSites();
        }

        if (!this.isQuickSignIn) {
          this.parentGrid == "notOnSite" &&
            (await this.checkUserHasVisitToday({
              siteIds: this.getModalInfo.sitesIds,
              userId: this.getModalInfo.user_id,
            }).then(async (data) => {
              if (data.data && data.data.userHasVisitToDayInOnOfSites) {
                this.userHasVisitToDayInOnOfSites =
                  data.data.userHasVisitToDayInOnOfSites;
                this.showModalMessage = true;
              } else {
                this.showModalMessage = false;
              }
            }));

          if (
            (this.getModalInfo?.scan_data_type_id == 6 && // signed out scan id : 6
              !this.getModalInfo?.hasPermissionOnProfileUserType && // flag for permission on profile user type
              this.getModalInfo.haveExpectedPermittedUserType) || // flag for permission on user type that was set when the visit was added
            (this.getModalInfo?.scan_data_type_id != 6 &&
              !this.getModalInfo.hasPermissionOnProfileUserType)
          ) {
            const expectedScan = this.getModalInfo.ExpectedScanSiteId;
            if (expectedScan) {
              this.site = this.siteOptions.find(
                (site) => site.id == this.getModalInfo.ExpectedScanSiteId
              );

              this.disableSite = true;
              this.updateSite(this.site);
            } else if (
              this.getModalInfo?.scan_data_type_id == 3 || //signed in scan id : 3
              this.getModalInfo?.scan_data_type_id == 9 //auto signed in scan id : 9
            ) {
              // visit is signed_in / auto_signed_in
              let siteId;
              let areaId;
              if (this.getModalInfo?.scan_data_type_id == 3) {
                siteId = this.getModalInfo.signed_in_scan_site_id;
                areaId = this.getModalInfo.signed_in_scan_area_id;
              } else {
                siteId = this.getModalInfo.auto_signed_in_scan_site_id;
                areaId = this.getModalInfo.auto_signed_in_scan_area_id;
              }
              this.site = this.siteOptions.find((site) => site.id == siteId);
              this.areaOptions = this.site.areas;
              // const area = this.site.areas.find( area =>area.id == areaId);
              this.area = { id: areaId };
              this.dontChangeArea = true;
              this.disableSite = true;
              this.disableArea = true;
              this.updateArea(this.area);
            }
          }
        }
      } catch (e) {
        console.error("Could not fetch api data : ", e);
      } finally {
        this.apiChecksLoader = false;
      }
    },
    setInfo() {
      // Determine user ID based on sign-in type
      const userId = this.determineUserId();
      // Determine default user status
      const isDefaultUser = this.determineIsDefaultUser();
      // Determine user type ID
      const userTypeId = this.determineUserTypeId();

      // Set properties based on determined values
      this.user_id = userId;
      this.isDefaultUser = isDefaultUser;
      this.user_type_id = userTypeId;

      // Check for walk-in default setting
      this.default_walk_in = this.currentEntity.id === this.user_id;
    },

    // Helper method to determine user ID
    determineUserId() {
      return !this.isQuickSignIn
        ? this.parentGrid === "users"
          ? this.getModalInfo.id
          : this.getModalInfo.user_id
        : this.isNewUser
        ? null
        : this.existingUserInfo?.user_id;
    },

    // Helper method to determine default user status
    determineIsDefaultUser() {
      return !this.isQuickSignIn
        ? this.getModalInfo.is_default_user
        : this.isNewUser
        ? false
        : this.existingUserInfo?.is_default_user;
    },

    // Helper method to determine user type ID
    determineUserTypeId() {
      return !this.isQuickSignIn
        ? this.getModalInfo?.user_type_id
        : this.existingUserInfo?.user_type_id || this.newUserInfo?.userType;
    },
    async setSites() {
      this.siteLoading = true;

      let { data: sites } = await visitService.getAllSitesWithAreasByEntityId();

      if (this.parentGrid == "notOnSite") {
        sites = sites.filter((site) => {
          return this.getModalInfo.sitesIds.some(
            (modalInfoSites) => site.id === modalInfoSites
          );
        });
      }
      this.siteOptions = sites;

      this.siteLoading = false;

      if (this.siteOptions?.length == 1) {
        this.site = this.siteOptions[0];
        this.updateSite(this.site);
      }
    },
  },
  async beforeMount() {
    this.showModalMessage = null;
    if (
      this.parentGrid == "users" ||
      this.parentGrid == "dashboard" ||
      this.isQuickSignIn
    )
      this.showModalMessage = false;

    this.setInfo();
    this.setMountData();
  },
};
</script>

<template>
  <div
    class="sign-in-container"
    :class="{
      hideBorder: !isDefaultUser && isUserSignedIn,
    }"
  >
    <template v-if="apiChecksLoader === true && !isQuickSignIn">
      <div class="apichecks-spinner-container">
        <b-spinner class="apichecks-spinner" variant="primary" role="status" />
      </div>
    </template>
    <template v-else>
      <div
        v-if="
          !(userHasVisitToDayInOnOfSites && parentGrid == 'notOnSite') &&
          showModalMessage === false &&
          !isQuickSignIn
        "
      >
        <svg
          class="close-btn"
          @click="$bvModal.hide('dashboardActionOne')"
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
            fill="#F46A6A"
          />
        </svg>
        <div class="header-container">
          <div class="site-area-spinner-container">
            <b-spinner
              :class="!!area && !areaChecksDone ? 'visible' : 'invisible'"
              class="spinner"
              variant="primary"
              role="status"
              size="sm"
            />
          </div>

          <span class="top-header-title">{{
            parentGrid == "notOnSite"
              ? $t("common.signIn")
              : $t("common.signInOut")
          }}</span>
        </div>
      </div>

      <div
        v-if="showModalMessage === null && !isQuickSignIn"
        class="checkInSpinnerDiv"
      ></div>
      <div
        v-if="
          parentGrid == 'notOnSite' &&
          userHasVisitToDayInOnOfSites &&
          !siteLoading &&
          showModalMessage &&
          !isQuickSignIn
        "
      >
        <CheckedInUserModal
          @refreshGrid="refreshUsersNotOnSiteGrid"
          :siteDetails="getSignedInUserVisitDetails"
          :user_name="getModalInfo.fullName"
        />
      </div>

      <div v-if="showModalMessage === false">
        <template v-if="!hideSiteAndArea">
          <div
            :class="{ 'vp-mb-40': !site || !area || (area && !areaChecksDone) }"
          >
            <div class="d-flex flex-column">
              <!-- start::site multiselect -->
              <vp-multiselect
                width="416"
                :showOptionsBorder="true"
                :loading="siteLoading && !site"
                label="name"
                trackBy="id"
                :title="$t('common.site')"
                v-model="site"
                :showPlaceholderIcon="true"
                dropDownStyle="relative"
                :options="siteOptions"
                :maxHeight="177"
                :placeholder="$t('common.site')"
                :show-labels="false"
                :allowEmpty="false"
                :invalid="siteErrMsg"
                :isLoading="siteLoading"
                :disabled="
                  siteLoading || (area && !areaChecksDone) || disableSite
                "
                @select="updateSite"
                class="vp-mb-16 site-multiselect"
              />
              <label
                class="site-error-note"
                v-show="siteErrMsg && siteErrMsg.length > 0"
                >{{ siteErrMsg }}</label
              >
              <!-- end::site multiselect -->

              <!-- start::area multiselect -->
              <vp-treeselect
                zIndex="10"
                :flatMode="false"
                :showPlaceholderIcon="true"
                width="416"
                :showOptionsBorder="true"
                :showNoResults="true"
                v-model="area"
                :options="areaOptions"
                :label="$t('common.area')"
                dropDownStyle="relative"
                :backspaceRemoves="false"
                :isMultiple="false"
                valueFormat="object"
                @select="updateArea"
                :disabled="
                  !site ||
                  (area && !areaChecksDone) ||
                  (siteErrMsg && siteErrMsg.length > 0) ||
                  disableArea
                "
              />
              <label
                class="site-error-note"
                v-show="attendanceModeErrMsg && attendanceModeErrMsg.length > 0"
                >{{ attendanceModeErrMsg }}</label
              >
            </div>

            <div
              v-if="!!area && areaChecksDone && isAttendanceModePermitted"
              class="site-area-note-container"
            >
              <p
                v-for="(msg, key, i) in areaStatus"
                :key="i"
                :class="{
                  'site-area-note':
                    key == 'journey' ||
                    key == 'attendanceMode' ||
                    key == 'attendanceModeDuration',
                }"
              >
                <template
                  v-if="
                    key == 'expected' ||
                    key == 'journey' ||
                    key == 'attendanceMode' ||
                    key == 'attendanceModeDuration'
                  "
                >
                  <span class="warning-note">{{ msg }}</span>
                </template>
              </p>

              <p
                v-for="(msg, key, i) in areaStatus"
                :key="i"
                :class="{
                  'site-area-note':
                    key == 'expected' ||
                    key == 'autoSignedOut' ||
                    key == 'autoSignedIn',
                }"
              >
                <template
                  v-if="key == 'autoSignedOut' || key == 'autoSignedIn'"
                >
                  <span class="normal-note"
                    ><b>{{ $t("common.notes.note") }}:</b> {{ msg }}</span
                  >
                </template>
              </p>
            </div>

            <div
              :class="{
                'custom-line-inside':
                  !hideSiteAndArea &&
                  area &&
                  areaChecksDone &&
                  isAttendanceModePermitted,
              }"
            ></div>
          </div>
        </template>

        <!-- form wizred  -->
        <div
          class="mt-1"
          :class="{
            'compliance-wizred': area,
            'header-border': !hideSiteAndArea && area,
            'hide-wizard-visibility': !areaChecksDone,
          }"
          v-if="showFormWizard"
        >
          <form-wizard
            class="custom-form-wizard form"
            :class="{
              'has-footer': showWizardNavButtons,
              'is-quick-sign-in': isQuickSignIn,
            }"
            ref="wizard"
            color="#103F5E"
            step-size="xs"
            @on-complete="onSubmit"
            @on-change="onWizardTabIndexChange"
            v-if="showSignInWizard"
          >
            <!-- Step 1  -->
            <tab-content icon="mdi mdi-account-cog-outline">
              <div class="scan-wrapper">
                <!-- tempreture type -->
                <template v-if="flowHasTemperatureCheck">
                  <h5 class="headers-label">
                    {{ $t("common.temperatureUnit") }}
                  </h5>
                  <v-radio-group v-model="scan.temperature_type">
                    <v-radio
                      :label="`°${$t('common.temperatureUnits.f')}`"
                      value="f"
                    />
                    <v-radio
                      :label="`°${$t('common.temperatureUnits.c')}`"
                      value="c"
                    />
                  </v-radio-group>

                  <!-- tempreture  -->
                  <b-form-group class="input-wrapper">
                    <div class="temp-group d-flex align-items-baseline">
                      <label class="form-sub-headers vp-mt-17"
                        >{{ $t("common.temperature") }}
                      </label>
                      <span
                        :class="{
                          'warning-color': $v.scan.temperature.$invalid,
                        }"
                        class="temperature-label"
                      >
                        {{ scan.temperature }} °{{
                          scan.temperature_type == "c"
                            ? $t("common.temperatureUnits.c")
                                .charAt(0)
                                .toUpperCase()
                            : $t("common.temperatureUnits.f")
                                .charAt(0)
                                .toUpperCase()
                        }}</span
                      >
                    </div>
                    <div
                      class="checks-warning-note"
                      v-if="$v.scan.temperature.$invalid"
                    >
                      {{ $t("signInOut.temperatureNote") }}
                    </div>

                    <b-slider
                      type=" "
                      v-model="$v.scan.temperature.$model"
                      :min="scan.temperature_type == 'c' ? 30 : 86"
                      :max="scan.temperature_type == 'c' ? 45 : 113"
                      :indicator="false"
                      :tooltip="false"
                      :step="0.1"
                      size="is-medium"
                      :rounded="true"
                    >
                    </b-slider>
                  </b-form-group>
                  <div class="custom-line-inside"></div>
                </template>
                <!-- mask  -->
                <template v-if="flowHasMaskCheck">
                  <h5 class="headers-label">
                    {{ $t("signInOut.hasAFaceMask") }}
                  </h5>
                  <v-radio-group v-model="$v.scan.mask.$model">
                    <v-radio :label="$t('common.yes')" :value="true" />
                    <v-radio
                      :class="{
                        'invalid-mask-check':
                          flowHasMaskCheck && scan.mask === false,
                      }"
                      :label="$t('common.no')"
                      :value="false"
                    />
                  </v-radio-group>
                  <div
                    class="checks-warning-note vp-mt-minus-2"
                    v-if="flowHasMaskCheck && scan.mask === false"
                  >
                    {{ $t("signInOut.maskNote") }}
                  </div>
                  <div class="custom-line-inside"></div>
                </template>
              </div>
              <div>
                <vp-textarea
                  v-model="checksNote"
                  rows="3"
                  maxlength="255"
                  :label="
                    isChecksTabInvalid
                      ? $t('common.notes.notes')
                      : `${$t('common.notes.note')} ${$t(
                          'common.optionalWithBrackets'
                        )}`
                  "
                  width="415"
                />

                <p class="checks-tab-note vp-mt-8" v-if="isChecksTabInvalid">
                  <span class="vp-font-weight-700">{{
                    $t("common.notes.note")
                  }}</span
                  >: {{ $tc("signInOut.complianceNote", 2) }}.
                </p>
              </div>
            </tab-content>

            <!-- step 2 -->
            <tab-content v-if="showHostTab">
              <p class="host-text-header">
                {{ $t("addExpectedVisitor.selectTheHost") }}
              </p>
              <div class="d-flex">
                <vp-multiselect
                  :class="
                    !allow_not_select_host && !haveUsersToSelectAsHost
                      ? 'is-invalid'
                      : ''
                  "
                  :options="hostOptions"
                  v-model="host"
                  :label="userSearchLabel"
                  :showPlaceholderIcon="true"
                  :isLoading="hostLoader"
                  trackBy="user_id"
                  :placeholder="
                    $t('addExpectedVisitor.searchByNamePhoneNumberEmail')
                  "
                  :show-labels="false"
                  :multiple="false"
                  @searchChange="findHost"
                  :disabled="!haveUsersToSelectAsHost"
                  zIndex="10"
                  dropDownStyle="relative"
                  :maxHeight="200"
                />
              </div>

              <span
                v-if="allow_not_select_host && !haveUsersToSelectAsHost"
                class="host-note-no-users-available"
                ><b>{{ $t("common.notes.note") }}:</b>
                {{
                  $t(
                    "addExpectedVisitor.noUsersAvailableSelectedAsHostCheckbox"
                  )
                }}</span
              >
              <div
                v-if="!allow_not_select_host && !haveUsersToSelectAsHost"
                class="host-error-no-users-available"
              >
                <span v-text="hostErrorMessage"></span>
              </div>

              <b-form-checkbox
                v-if="allow_not_select_host"
                v-model="isNoHostSelected"
                class="d-flex justify-content-center host-message"
              >
                <span v-text="hostMessage"></span>
              </b-form-checkbox>
            </tab-content>

            <!-- Step 3  -->
            <tab-content v-if="showReasonTab">
              <div>
                <p
                  class="vp-color-grey-5 vp-width-378 vp-mb-30 text-center vp-font-size-16 vp-ml-12"
                >
                  {{ $tc("signInOut.lateSignin", 2) }}.
                </p>

                <div>
                  <!-- start::reason multiselect -->
                  <vp-multiselect
                    v-model="$v.reason.$model"
                    :options="attendanceModeReasons"
                    :placeholder="$t('attendanceModes.reason.reason')"
                    title="Reason"
                    :show-labels="false"
                    label="name"
                    :allowEmpty="false"
                    dropDownStyle="relative"
                    :maxHeight="200"
                  />
                  <!-- end::reason multiselect -->
                </div>
              </div>
            </tab-content>

            <!-- Step 4  -->
            <!-- :before-change="() => beforeTabOneSwitch(el)" -->
            <tab-content
              v-for="(el, i) in $v.compliances.$model"
              :key="i"
              icon="mdi mdi-account-details-outline"
            >
              <!-- @isComplianceValid="checkCompliancesValidity" -->
              <ComplianceForm
                :element="el"
                :index="i"
                @updateCompliance="updateCompliance"
              />
              <div>
                <p class="tab-note">
                  <span style="font-weight: 700">{{
                    $t("common.notes.note")
                  }}</span
                  >: {{ $t("signInOut.mandatoryNotes") }}
                </p>
                <vp-textarea
                  v-model="compliancesNotes[i]"
                  width="415"
                  rows="3"
                  :label="$tc('signInOut.complianceNote', 1)"
                  :class="{
                    'cursor-stop':
                      compliancesNotes[i] && compliancesNotes[i].length >= 255,
                  }"
                  maxlength="255"
                  no-resize
                ></vp-textarea>
              </div>
            </tab-content>
            <!-- Step 4  -->
            <tab-content
              v-if="vaccine_pcr.flow_has_vaccine"
              icon="mdi mdi-account-check-outline"
              class="vp-ma-auto"
            >
              <div class="scan-wrapper">
                <DocumentForm
                  :vaccineComplianceName="vaccineComplianceName"
                  :isPcrEnabled="isPcrEnabled"
                  :isOptional="isOptional"
                  :vaccine_pcr="vaccine_pcr"
                  :submitted="submitted"
                  :validation="$v"
                  :default_walk_in="default_walk_in"
                  :isLoading="getLoadingStatus"
                  @vaccineProtocolChange="updateVaccineProtocol"
                  @updateIsOptional="updateIsOptional"
                />
              </div>
              <div class="document-notes-container">
                <div>
                  <p class="tab-note">
                    <span style="font-weight: 700">{{
                      $t("common.notes.note")
                    }}</span
                    >: {{ $t("signInOut.mandatoryNotes") }}
                  </p>
                  <vp-textarea
                    id="flow_description"
                    width="415"
                    v-model="documentNotes"
                    rows="3"
                    :class="{
                      'cursor-stop':
                        documentNotes && documentNotes.length >= 255,
                    }"
                    maxlength="255"
                    :placeholder="$tc('signInOut.complianceNote', 1)"
                    no-resize
                  ></vp-textarea>
                </div>
              </div>
            </tab-content>

            <!-- Step 5 (Custom fields) -->
            <tab-content v-for="section in customSections" :key="section.id">
              <div>
                <RenderFieldType
                  :addSeperator="true"
                  :section="section"
                  :signin="true"
                  @updateCustomField="updateCustomField"
                />
              </div>
            </tab-content>

            <div slot="footer" slot-scope="props">
              <div
                class="next-back-container"
                :class="{
                  'd-none': !showWizardNavButtons,
                  'vp-ml-90': isQuickSignIn,
                }"
              >
                <div class="wizard-footer-left" v-if="showWizardNavButtons">
                  <wizard-button
                    class="back-btn"
                    :disabled="backBtnDisabled(props.activeTabIndex)"
                    @click.native="
                      props.prevTab(),
                        setActiveTabIndex(props.activeTabIndex - 1)
                    "
                    >{{ $t("common.back") }}</wizard-button
                  >
                </div>

                <div class="wizard-footer-right" v-if="showWizardNavButtons">
                  <wizard-button
                    class="next-btn"
                    :disabled="
                      props.isLastStep ||
                      $v.scan.$invalid ||
                      $v.areaStatus.$invalid ||
                      ($v.host.$invalid && props.activeTabIndex == 1) ||
                      (props.activeTabIndex >= skipTabContent &&
                        props.activeTabIndex < customSectionSkipIndex &&
                        $v.compliances.$each.$iter[
                          props.activeTabIndex - skipTabContent
                        ] &&
                        $v.compliances.$each.$iter[
                          props.activeTabIndex - skipTabContent
                        ].$invalid) ||
                      (props.activeTabIndex >=
                        skipTabContent + compliances.length &&
                        $v.vaccine_pcr.$invalid) ||
                      ($v.reason.$invalid &&
                        ((!showHostTab && props.activeTabIndex == 1) ||
                          (showHostTab && props.activeTabIndex == 2))) ||
                      (props.activeTabIndex >= customSectionSkipIndex &&
                        $v.customSections.$each.$iter[
                          props.activeTabIndex - customSectionSkipIndex
                        ].$invalid)
                    "
                    @click.native="
                      props.nextTab(),
                        setActiveTabIndex(props.activeTabIndex + 1)
                    "
                    >{{ $t("common.next") }}
                  </wizard-button>
                </div>
              </div>

              <div v-if="!isQuickSignIn">
                <wizard-button
                  class="wizard-submit-btn"
                  :disabled="$v.$invalid || getLoadingStatus"
                  :style="props.fillButtonStyle"
                  @click.native="onSubmit()"
                >
                  <i
                    v-if="getLoadingStatus"
                    class="bx bx-hourglass bx-spin font-size-16 mr-2"
                  ></i>
                  {{ buttonValue }}
                </wizard-button>
              </div>
            </div>
          </form-wizard>

          <template v-if="isUserSignedIn && !isDefaultUser">
            <form-wizard
              class="custom-form-wizard form"
              :class="{
                'has-footer': showWizardNavButtons,
                'is-quick-sign-in': isQuickSignIn,
              }"
              ref="wizard"
              color="#103F5E"
              step-size="xs"
              @on-change="onWizardTabIndexChange"
            >
              <!-- Content 1 -->
              <tab-content>
                <vp-textarea
                  v-model="checksNote"
                  rows="3"
                  maxlength="255"
                  :label="
                    isChecksTabInvalid
                      ? $t('common.notes.notes')
                      : `${$t('common.notes.note')} ${$t(
                          'common.optionalWithBrackets'
                        )}`
                  "
                  width="415"
                />

                <p class="checks-tab-note vp-mt-8" v-if="isChecksTabInvalid">
                  <span class="vp-font-weight-700">{{
                    $t("common.notes.note")
                  }}</span
                  >: {{ $tc("signInOut.complianceNote", 2) }}
                </p>
              </tab-content>

              <!-- Step 2 (Custom fields) -->
              <tab-content v-for="section in customSections" :key="section.id">
                <RenderFieldType
                  :section="section"
                  :addSeperator="true"
                  :signin="true"
                  @updateCustomField="updateCustomField"
                />
              </tab-content>

              <!-- Content 3 (Reason tab) -->
              <tab-content v-if="showReasonTab">
                <div>
                  <p
                    class="vp-color-grey-5 vp-width-378 vp-mb-30 text-center vp-font-size-16 vp-ml-12"
                  >
                    {{ $tc("signInOut.earlySignOut", 2) }}
                  </p>

                  <div>
                    <!-- start::reason multiselect -->
                    <vp-multiselect
                      v-model="$v.reason.$model"
                      :options="attendanceModeReasons"
                      placeholder="Reason"
                      title="Reason"
                      :show-labels="false"
                      label="name"
                      :allowEmpty="false"
                      dropDownStyle="relative"
                      :maxHeight="200"
                    />
                    <!-- end::reason multiselect -->
                  </div>
                </div>
              </tab-content>

              <!-- Wizard footer -->
              <div slot="footer" slot-scope="props">
                <div
                  class="next-back-container"
                  :class="{ 'd-none': !showWizardNavButtons }"
                >
                  <div
                    class="wizard-footer-left"
                    v-if="showReasonTab || customSections.length"
                  >
                    <wizard-button
                      class="back-btn"
                      :disabled="backBtnDisabled(props.activeTabIndex)"
                      @click.native="
                        props.prevTab(),
                          setActiveTabIndex(props.activeTabIndex - 1)
                      "
                      >{{ $t('common.back') }}</wizard-button
                    >
                  </div>

                  <div
                    class="wizard-footer-right"
                    v-if="showReasonTab || customSections.length"
                  >
                    <wizard-button
                      class="next-btn"
                      :disabled="
                        props.isLastStep ||
                        $v.areaStatus.$invalid ||
                        ($v.reason.$invalid && props.isLastStep) ||
                        (props.activeTabIndex > 0 &&
                          $v.customSections.$each.$iter[
                            props.activeTabIndex - 1
                          ].$invalid)
                      "
                      @click.native="
                        props.nextTab(),
                          setActiveTabIndex(props.activeTabIndex + 1)
                      "
                      >{{ $t("common.next") }}</wizard-button
                    >
                  </div>
                </div>

                <div v-if="!isQuickSignIn">
                  <wizard-button
                    class="wizard-submit-btn"
                    :disabled="
                      $v.reason.$invalid ||
                      getLoadingStatus ||
                      $v.areaStatus.$invalid ||
                      $v.customSections.$invalid
                    "
                    :style="props.fillButtonStyle"
                    @click.native="onSubmit()"
                  >
                    <i
                      v-if="getLoadingStatus"
                      class="bx bx-hourglass bx-spin font-size-16 mr-2"
                    ></i>
                    {{ signOutBtnValue }}
                  </wizard-button>
                </div>
              </div>
            </form-wizard>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>
<style lang="scss">
#dashboardActionOne___BV_modal_content_ {
  width: 491px;
  border-radius: 26px;
  #dashboardActionOne___BV_modal_body_ {
    padding: 40px 38px 0 38px !important;
  }
}

.sign-in-container {
  position: relative;

  .apichecks-spinner-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: fit-content;
    margin: auto;
    height: 150px;

    .apichecks-spinner {
      width: 3rem;
      height: 3rem;
    }
  }

  .vue-form-wizard {
    padding-bottom: unset;
  }

  .warning-color {
    color: #f46a6a !important;
  }
  .invalid-mask-check {
    label {
      color: #f46a6a;
    }
    .theme--light.v-icon {
      color: #f46a6a;
    }
  }
  .checks-warning-note {
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    color: #f46a6a;
    width: 416px;
    margin-top: 17px;
    margin-bottom: -2px;
  }
  .headers-label {
    font-size: 16px;
    font-weight: 600;
    color: #787878;
    margin-bottom: 32px;
  }
  .temperature-label {
    background-color: #f2f2f2;
    border-radius: 7px;
    font-weight: 700;
    font-size: 16px;
    line-height: 19.2px;
    height: 28px;
    width: 65px;
    display: flex;
    align-items: center;
    justify-content: center;
    letter-spacing: 0.25px;
    margin-inline-start: 29px !important;
    color: #4a4a4a;
  }
  .form-sub-headers {
    font-weight: 700;
    color: #939393;
    line-height: 19.2px;
    font-size: 16px;
    label {
      color: #606060;
      font-weight: 400;
      line-height: 17px;
      opacity: 0.87;
    }
  }

  .top-header-title {
    font-weight: 700;
    font-size: 17px;
    line-height: 20.4px;
    color: #000000;
  }
  .close-btn {
    position: absolute;
    inset-inline-end: -7px;
    top: -1px;
  }
  .close-btn:lang(ar){
    inset-inline-end: unset;
  }

  .bv-no-focus-ring {
    padding-bottom: 0;
  }

  .site-area-note-container {
    display: flex;
    flex-direction: column;
    // width: 416px;
    margin: auto;
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    svg {
      display: block;
      margin-inline-end: 10px;
      margin-top: 2px;
    }
  }

  .site-area-note {
    display: flex;
    margin-top: 16px;
    word-break: break-word;
  }
  .normal-note,
  .warning-note,
  .site-error-note {
    font-size: 14px;
    line-height: 22px;
  }

  b {
    font-weight: 700;
    color: #787878;
  }
  .normal-note {
    color: #787878;
    font-weight: 400;
  }
  .warning-note,
  .site-error-note {
    color: #f46a6a;
    font-weight: 600;
  }

  .site-error-note {
    margin: -7px 20px 16px;
  }

  .custom-line-inside {
    height: 1px;
    background: #000000;
    margin: 24px auto;
    opacity: 0.08;
  }

  .tab-note,
  .checks-tab-note {
    width: 380px;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: 0.25px;
  }

  .checks-tab-note {
    margin: 9px auto 0;
    color: #787878;
  }
  .tab-note {
    margin: 0 auto 9px;
    color: #939393;
  }

  .b-slider {
    margin: 24px auto 0;
  }

  .b-slider-track,
  .b-slider-fill {
    width: 388px;
    background-image: linear-gradient(
      89.98deg,
      #ffb545 3.49%,
      #fd7430 43.24%,
      #fc3205 97.7%
    ) !important;
  }
  .b-slider-thumb::before {
    background-color: red;
  }

  .header-container {
    margin-bottom: 40px;
    display: flex;
    justify-content: center;
    margin-inline-start: -30px;
    .site-area-spinner-container {
      width: fit-content;
      // margin: auto;
      .spinner {
        width: 17px;
        height: 17px;
        border-right-color: #d9d9d9;
        font-size: 11px;
        margin-inline-end: 20px;
        margin-top: 2px;
      }
    }
  }

  .host-text-header {
    width: fit-content;
    margin: auto;
    font-weight: 700;
    font-size: 16px;
    text-align: center;
    color: #939393;
    margin-bottom: 32px;
  }
  .host-message {
    // background-color: red;
    width: fit-content;
    margin: 24px auto 0;
    padding-inline-start: 0;
  }

  .host-message .custom-control-label {
    display: flex;
    span {
      margin-top: -3px;
    }
  }
  .host-error-no-users-available {
    font-size: 14px;
    font-weight: 400;
    line-height: 16.8px;
    letter-spacing: 0.25px;
    text-align: start;
    color: #939393;
    width: 320px;
    margin: 8px auto 0;
  }

  // Wizard UI
  .wizard-card-footer {
    padding: 0 !important;
  }

  .wizard-progress-with-circle {
    display: none;
  }

  // Footer buttons
  .wizard-footer-left,
  .wizard-footer-right {
    button {
      background: none;
      border: none;
      padding: 0;

      letter-spacing: 0.25px;
      line-height: 17px;
      font-weight: 700;
      font-size: 16px;
      color: #103f5e;
      min-width: unset;
    }
    button:disabled {
      color: #606060de;
    }
  }

  .wizard-submit-btn {
    font-weight: 700;
    font-size: 16px;
    line-height: 17px;
    letter-spacing: 0.25px;
    height: 44px;
    background: #103f5e;
    width: 415px;
    border-radius: 22px !important;
    margin: 40px auto !important;
  }

  .wizard-card-footer .next-back-container {
    width: 300px;
    margin: auto;
  }

  // Navigation pills
  .has-footer .wizard-navigation {
    display: flex;
    flex-direction: column;
    .wizard-tab-content {
      order: 1;
      margin-bottom: 29px;
    }
    .wizard-nav-pills {
      order: 2;
      width: fit-content;
      margin: auto;
      transform: translateY(13px);
    }
    .wizard-progress-with-circle {
      order: 3;
    }

    .wizard-nav {
      .wizard-icon-circle {
        border-color: #c7c7c7 !important;
        background-color: #c7c7c7 !important;
      }
      li {
        margin-inline-end: 6px;
        a {
          .wizard-icon-circle {
            height: 8px;
            width: 8px;
            .wizard-icon-container {
              .wizard-icon {
                display: none !important;
              }
            }
            .wizard-icon {
              display: none !important;
            }
          }
        }
      }
      li.active .wizard-icon-circle.md.checked {
        border-color: #103f5e !important;
        background-color: #103f5e !important;
      }
    }
  }

  .is-quick-sign-in {
    margin-bottom: -4px;
  }
  .has-footer.is-quick-sign-in .wizard-navigation {
    .wizard-nav-pills {
      transform: translateY(16px) translatex(23px);
    }
  }

  .wizard-tab-content {
    padding: unset !important;
  }
}

.site-multiselect .multiselect__content-wrapper {
  max-height: 172px !important;
}
</style>
